import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: '🧪',
    title: 'CUET UG Mock Test',
    description: 'Experience real exam scenarios with full-length free CUET UG mock tests. Instant score, performance analysis, and exam-level questions.',
    link: '/cuet-ug-mock-test',
    linkText: 'Start Free Mock Test'
  },
  {
    icon: '📚',
    title: 'CUET Study Materials',
    description: 'Download free PDFs for CUET UG, CUET PG, and UGC NET/JRF. Topic-wise notes, concept explanations, and exam-focused content.',
    link: '/study-materials',
    linkText: 'Download Materials'
  },
  {
    icon: '📄',
    title: 'PYQ of CUET',
    description: 'Practice with CUET UG & PG previous year question papers. Understand real exam patterns, important topics, and question trends.',
    link: '/pyq-cuet',
    linkText: 'Download PYQs'
  },
  {
    icon: '🎥',
    title: 'Self-Paced Learning',
    description: 'Expert-led recorded classes for CUET UG & PG with structured modules, mock tests, and study materials — learn anytime, anywhere.',
    link: '/self-paced',
    linkText: 'Explore Courses'
  },
  {
    icon: '🌍',
    title: 'Current Affairs Test',
    description: 'Stay ahead with free daily current affairs tests and GK quizzes. Instant results and performance tracking for competitive exams.',
    link: '/current-affairs-test',
    linkText: 'Start Today\'s Test'
  },
  {
    icon: '📢',
    title: 'News & Updates',
    description: 'Stay updated with the latest CUET, UGC NET, and competitive exam notifications, syllabus changes, results, and announcements.',
    link: '/news-updates',
    linkText: 'View Latest Updates'
  },
  {
    icon: '🧠',
    title: 'Free Reasoning Test',
    description: 'Sharpen your logical thinking with free reasoning tests. Easy to advanced levels with instant results for all competitive exams.',
    link: '/reasoning-test',
    linkText: 'Start Reasoning Test'
  },
  {
    icon: '📝',
    title: 'UGC NET Paper 1 Mock Test',
    description: 'Free UGC NET Paper 1 mock tests based on the latest NTA syllabus. Instant score, detailed analysis, and all 9 units covered.',
    link: '/ugc-net-mock',
    linkText: 'Start Mock Test'
  },
  {
    icon: '🎓',
    title: 'CUET Counselling',
    description: 'Free expert counselling for CUET UG & PG admissions. College selection, cut-off analysis, and complete admission strategy guidance.',
    link: '/cuet-counselling',
    linkText: 'Book Free Counselling'
  },
  {
    icon: '📈',
    title: 'Digital Marketing Course',
    description: 'Become job-ready in 2 months with our Advanced Digital Marketing Program. Live project, industry tools, and certification included.',
    link: '/digital-marketing',
    linkText: 'Enroll Now'
  },
];

const ServicesSection = () => {
  return (
    <section className="py-32 relative" id="services">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="section-title">What BESST Offers</h2>
          <p className="section-subtitle">
            Revolutionary learning solutions powered by cutting-edge technology and expert guidance
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">
                {service.title}
              </h3>
              <p className="text-text-muted leading-relaxed mb-8">
                {service.description}
              </p>
              <Link to={service.link} className="service-btn">
                {service.linkText}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;